import React from 'react'
import { Col, Grid, Panel } from 'rsuite'
import ProductPrices from '../form/price/ProductPrices'
import type { GQL_ID } from '@@partner:types:graphql'
import type { ProductPrice } from '@@partner:types:app'

export interface ProductPricesTabProps {
  shopIds: GQL_ID[]
  prices: ProductPrice[]
  loadingProduct: boolean
}

export default function ProductPricesTab ({
  shopIds,
  prices,
  loadingProduct
}: ProductPricesTabProps) {
  return (
    <Grid fluid className="my-5">
      <Col xs={24}>
        <Panel shaded header="Цены">
          <ProductPrices
            shopIds={shopIds}
            prices={prices}
            loadingProduct={loadingProduct}
          />
        </Panel>
      </Col>
    </Grid>
  )
}
